import _ from 'underscore';

import Localize from 'app/src/localize/Localize';

export default class PaymentServiceAlert {
  static alert(strOrJqXHR) {
    alertUser(_formatMessage(strOrJqXHR));
  }

  static warn(strOrJqXHR) {
    warnUser(_formatMessage(strOrJqXHR));
  }
}

function _formatMessage(strOrJqXHR) {
  let response = _.isString(strOrJqXHR) ? strOrJqXHR : JSON.parse(strOrJqXHR.responseText);
  let output_str = '';

  if (_.isString(response)) {
    output_str = response;
  } else if (typeof response.message === 'undefined') {
    // No message, so output a generic one
    output_str =
      `${Localize.translate(
        'An error occurred and we’ve been notified. Please try again. If the problem persists, '
      )}<a class="strong-link" target="_blank"` +
      `href="https://www.lightspeedhq.com/support/retail">${Localize.translate(
        'contact Support'
      )}</a>. - ${response.httpCode}`;
  } else {
    // If there is a message, output it
    output_str = `${Localize.translate(response.message)}`;

    // If there is a detailed message, use this one too
    if (typeof response.detailedMessage !== 'undefined' && response.detailedMessage.length > 0) {
      output_str += `<br />${response.detailedMessage}`;
    }
    output_str += ` — ${response.httpCode}`;
    // Also output the custom error code if there is one
    if (typeof response.errorCode !== 'undefined') {
      output_str += ` (${response.errorCode})`;
    }
  }

  return output_str;
}
